// <![CDATA[
$(document).ready(function () {
  // When an accordion header is clicked
  $(".accordion__header").click(function () {
    $(this).toggleClass("active");
    $(this).next(".accordion__body").slideToggle();
  });

  $("#faq-load-more").click(function () {
    $(this).hide();
    $(this).siblings(".accordion__header").show();
    $(this).siblings("#faq-load-less").css('display', 'block');
  });

  $('#faq-load-less').click(function(){
    $(this).hide();
    $(this).siblings("#faq-load-more").show();
    $(this).siblings("#faq-load-more ~ .accordion__header").hide();
    $(this).siblings("#faq-load-more ~ .accordion__body").hide();
  });

  // Get current browser time
  var now = new Date();

  // Get current hour in 24-hour format
  var currentHour = now.getHours();

  // Disable phone button if current time is outside 9am to 5pm
  if (currentHour < 9 || currentHour >= 17) {
    $(".faq-phone-icon, .faq-chat-icon")
      .click(function (event) {
        event.preventDefault(); // Prevents the default link behavior
      })
      .addClass("disabled");
  } else {
    $(".faq-button-icon.faq-chat-icon").click(function (e) {
      e.preventDefault();
      $("#tidio-chat-iframe").contents().find("#button-body").click();
    });
  }
});
// ]]>
